import { CANDIDATE_STATUS_LABELS, type CandidateStatus } from "@shared/modules/x-candidats";
import { Badge } from "../../../core/components/ui/badge";

const VARIANT: Record<CandidateStatus, "neutral" | "primary" | "success" | "warning" | "danger" | "info"> = {
  nouveau: "info",
  en_evaluation: "primary",
  dossier_en_cours: "warning",
  soumis_avocat: "primary",
  approuve: "success",
  refuse: "danger",
  archive: "neutral",
};

export function StatusBadge({ status }: { status: CandidateStatus }) {
  return <Badge variant={VARIANT[status] ?? "neutral"}>{CANDIDATE_STATUS_LABELS[status] ?? status}</Badge>;
}
